module.exports = __webpack_public_path__ + "static/media/gryphon-house-rooftop.afb21ebc.jpeg";